import React from 'react'
import CveRecord from './Cverecord'

let Datagrid = (props) => {

    return (

        <section id="report-section">
          <div className="container">
            <div className="report-title">
              <p className="h3">{props.title} <small className="muted">Common Vulnerabilities and Exposures (CVE)</small></p>
            </div>
            <div className="cve-table-container">
                <table className="table table-striped table-sm">
                  <thead className="thead-light">
                    <tr>
                        <th scope="col">ID</th>
                        <th scope="col">SEVERITY</th>
                        <th scope="col">CATEGORY</th>
                        <th scope="col">PRODUCT(S)</th>
                        <th scope="col">DATE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.cves.map((e,i) => {
                        return (
                            <CveRecord key={i} cve={e}/>
                        )
                    })}                          
                  </tbody>
                </table>
            </div>
          </div>
        </section>
    )
}

export default Datagrid;